import type { AgentLoginByPasswordInput } from '../../../base-api/Api'
import { api } from '../../api'

export const agentLoginByPassword = async (data: AgentLoginByPasswordInput) => {
  return await api.v1.agentLoginByPassword(data)
}
